import ServerApi from './ServerApi';
import { getDefaultLanguage } from 'lib/languages';

class KindApi extends ServerApi {
  getKindList(companyId, partner) {
    const company = companyId ? `&company=${companyId}` : '';
    const partnerOd = partner ? `&partner=${partner}` : '';
    return super.get(
      `/v1/recruiting/vacancykind/?language=${getDefaultLanguage()}${company}${partnerOd}`
    );
  }
}

export default new KindApi();
